import { computed } from 'vue';
import { format } from 'date-fns-tz';

import { useUserStore } from '@/stores/useUserStore';
import * as dateHelpers from '@/helpers/date';
import * as datePickerLabels from '@/constants/datePickerLabels';

export interface CurrentDateStringComposable {
  getCurrentDateString: () => string;
  getCurrentQueryDate: () => Date;
  getLastSevenDaysRange: () => [Date, Date];
  getLast14DaysRange: () => [Date, Date];
  getNextFiveDaysRange: () => [Date, Date];
  getLast6MthsNext6MthsRange: () => [Date, Date];
  getLast7DaysNext5DaysRange: () => [Date, Date];
}

export default function useCurrentDateString(): CurrentDateStringComposable {
  const userStore = useUserStore();

  const userTimeZone = computed(() => userStore.user.timezone);

  function getCurrentDateString(): string {
    const date = dateHelpers.getUserZonedTodayDate(userTimeZone.value);
    return format(date, 'yyyy-MM-dd');
  }

  function getCurrentQueryDate(): Date {
    return dateHelpers.getUserZonedTodayDate(userTimeZone.value);
  }

  function getLastSevenDaysRange(): [Date, Date] {
    return dateHelpers.getDatePickerPresetValue(
      datePickerLabels.LAST_7_DAYS,
      userTimeZone.value,
    );
  }

  function getLast14DaysRange(): [Date, Date] {
    return dateHelpers.getDatePickerPresetValue(
      datePickerLabels.LAST_14_DAYS,
      userTimeZone.value,
    );
  }

  function getNextFiveDaysRange(): [Date, Date] {
    return dateHelpers.getDatePickerPresetValue(
      datePickerLabels.NEXT_5_DAYS,
      userTimeZone.value,
    );
  }

  function getLast6MthsNext6MthsRange(): [Date, Date] {
    return dateHelpers.getDatePickerPresetValue(
      datePickerLabels.LAST_6_MTHS_NEXT_6_MTHS,
      userTimeZone.value,
    );
  }

  function getLast7DaysNext5DaysRange(): [Date, Date] {
    return dateHelpers.getDatePickerPresetValue(
      datePickerLabels.LAST_7_DAYS_NEXT_5_DAYS,
      userTimeZone.value,
    );
  }

  return {
    getCurrentDateString,
    getCurrentQueryDate,
    getLastSevenDaysRange,
    getLast14DaysRange,
    getNextFiveDaysRange,
    getLast6MthsNext6MthsRange,
    getLast7DaysNext5DaysRange,
  };
}
